/*
	Custom Number Spinner Function for Bold Options v2
	Created by Crema Design Studio
	Updated on July 19, 2017
*/

// https://paul.kinlan.me/waiting-for-an-element-to-be-created/
function waitForElement(selector) {
	return new Promise(function(resolve, reject) {
		var element = document.querySelector(selector);
		
		if(element) {
			resolve(element);
			return;
		}
		
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				var nodes = Array.from(mutation.addedNodes);
				
				for(var node of nodes) {
					if(node.matches && node.matches(selector)) {
						observer.disconnect();
						resolve(node);
						return;
					}
				};
			});
		});
		
		observer.observe(document.documentElement, { childList: true, subtree: true });
	});
}

// URL Parameter Function
var getUrlParameter = function getUrlParameter(sParam) {
	var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;
	
	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');
		
		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
};

// Number Spinner Fuction
function chkSpinValue($input) {
	//console.log("Now checking the spin values...");
	
	var $form = $input.closest('form'),
		$btnSpinner = $input.closest('.bold_option_element').find('button'),
		$alert = $form.find('.alert-totals'),
		$btnSubmit = $form.find('button.bold_clone'),
		comboAmount = $alert.data("amount"),
		sum = 0;
	
	$form.find('input').each(function() {
		var value = $(this).val();
		
		sum += Number(value);
		
		if (value > 0) {
			$(this).addClass('valid');
		} else {
			$(this).removeClass('valid');
		}
	});
	
	if (sum == comboAmount) {
		$alert.addClass('alert-success').removeClass('alert-warning text-bold');
		$btnSubmit.removeClass('disabled').attr('disabled',false).attr("type","submit");
	} else {
		$alert.addClass('alert-warning text-bold').removeClass('alert-success');
		$btnSubmit.addClass('disabled').attr('disabled',true).attr("type","button");
	}
	
	$alert.find('.sum').text(sum);
	
	return [sum, comboAmount];
};

// All of these functions have to be loaded AFTER the Bold Options plugin

function numberSpinner() {
	/* ===========================================================================================
		NUMBER SPINNER FUNCTIONS
	=========================================================================================== */
	var comboAmount = $('#add-to-cart-form .alert-totals').data("amount");
	
	$(".bold_option_textbox").each(function () {
		console.log("Looping through Bold Option's " + window.BOLD.options.version + " Checkboxes...");
		
		var $this = $(this),
			$input = $this.find('input'),
			$title = $this.find('.bold_option_title'),
			$inputWrap = $this.find('.bold_option_element');
		
		var btnDown = '<span class="input-group-btn"><button type="button" class="btn btn-default" data-dir="dwn"><i class="fa fa-minus"></i></button></span>';
		var btnUp =   '<span class="input-group-btn"><button type="button" class="btn btn-default" data-dir="up"><i class="fa fa-plus"></i></button></span>';
		
		// Add Bootstrap Grid
		$inputWrap.addClass('');
		//$title.clone().prependTo($this).wrap('<label class="visible-xs text-center" />');
		$title.addClass('col-xs-12').appendTo($this);
		
		// Reformat Input Boxes to look like a Spinner
		$inputWrap.unwrap().addClass('input-group number-spinner');
		$inputWrap.find('input').addClass('form-control text-center').attr('value',0).attr('min',0).attr('max',comboAmount).removeAttr("style");
		$inputWrap.prepend(btnDown).append(btnUp);
		
		// Check value on load
		var getVal = chkSpinValue($input);
		
		// http://stackoverflow.com/questions/2917175/return-multiple-values-in-javascript
		//console.log("Sum: " + getVal[0]);
		//console.log("Combo Amount vB: " + getVal[1]);
		
		// Unhide Bold Options, so there isn't a visual glitch
		$this.addClass('bold_option_spinner block');
	});
	
	//console.log("We got past the textboxes!");
	/*/
		I had it glitch on sauces and it got to the statement above. That seems impossible though, since NONE of my reformatting code has been rendered. I DID notice though, that it's only loading these three messages:
		• Crema's loadFunction Loading...
		• Combo Amount: 6
		• We got past the textboxes!
		
		So that means, it's not looping through the .bold_option_textboxes at all...
	/*/
	
	$(".number-spinner button").click(function () {
		//console.log("Button Spinner Click Function Loading...");
		
		var $input = $(this).closest('.bold_option_element').find('input');
		
		$(this).closest('.bold_option_element').find('button').prop("disabled", false);
		
		if ($(this).attr('data-dir') == 'up') {
			if ($input.attr('max') == undefined || parseInt($input.val()) < parseInt($input.attr('max'))) {
				$input.val(parseInt($input.val())+1);
			} else {
				$btnSpinner.prop("disabled", true);
			}
		} else {
			if ($input.attr('min') == undefined || parseInt($input.val()) > parseInt($input.attr('min'))) {
				$input.val(parseInt($input.val())-1);
			} else {
				$btnSpinner.prop("disabled", true);
			}
		}
		
		// Check value on click
		var getVal = chkSpinValue($input);
		
		// http://stackoverflow.com/questions/2917175/return-multiple-values-in-javascript
		//console.log("Sum: " + getVal[0]);
		//console.log("Combo Amount vC: " + getVal[1]);
	});
};

function optionPresets() {
	var original = getUrlParameter('original');
	var cajun = getUrlParameter('cajun');
	var andouille = getUrlParameter('andouille');
	var green_onion = getUrlParameter('green_onion');
	var jalepeno_cheddar = getUrlParameter('jalepeno_cheddar');
	var juniors = getUrlParameter('juniors');
	var pepperjack_greenonion = getUrlParameter('pepperjack_greenonion');
	
	var bbq_rub = getUrlParameter('bbq_rub');
	var burgundy_wine = getUrlParameter('burgundy_wine');
	var drunk_chicken = getUrlParameter('drunk_chicken');
	var smokers_rub = getUrlParameter('smokers_rub');
	
	var slop_sauce = getUrlParameter('slop_sauce');
	var grillin_chillin = getUrlParameter('grillin_chillin');
	
	/*/
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const entries = urlParams.entries();
	
	for (const entry of entries) {
		console.log(`${entry[0]}: ${entry[1]}`);
	}
	/*/
	
	/* ===========================================================================================
		URL PARAMETER FUNCTIONS
		For example:
		* https://country-pleasin.myshopify.com/products/sausage-combo?original=3&andouille=1&juniors=2
		* https://country-pleasin.myshopify.com/products/spice-combo?smokers_rub=2&drunk_chicken=1&bbq_rub=1
	=========================================================================================== */
	
	console.log("option preset");
	
	
	/* === SAUSAGE COMBOS ===================================================================== */
	
	if (original !== undefined) {
		$('input[name="properties[Original]"]').val(original).addClass('valid');
		//console.log("Original: " + original);
		// I'm not seeing this in the log, because original has no value.
	}
	
	if (cajun !== undefined) {
		$('input[name="properties[Cajun Style]"]').val(cajun).addClass('valid');
		//console.log("Cajun: " + cajun);
	}
	
	if (andouille !== undefined) {
		$('input[name="properties[Andouille]"]').val(andouille).addClass('valid');
		//console.log("Andouille: " + andouille);
	}
	
	if (green_onion !== undefined) {
		$('input[name="properties[Green Onion]"]').val(green_onion).addClass('valid');
		//console.log("Green Onion: " + green_onion);
	}
	
	if (jalepeno_cheddar !== undefined) {
		$('input[name="properties[Jalapeno & Cheddar]"]').val(jalepeno_cheddar).addClass('valid');
		//console.log("Jalapeno Cheddar: " + jalepeno_cheddar);
	}
	
	if (juniors !== undefined) {
		$('input[name="properties[Juniors]"]').val(juniors).addClass('valid');
		//console.log("Juniors: " + juniors);
	}
	
	if (pepperjack_greenonion !== undefined) {
		$('input[name="properties[Pepper Jack & Green Onion]"]').val(pepperjack_greenonion).addClass('valid');
		//console.log("Pepper Jack: " + pepperjack_greenonion);
	}
	
	/* === SPICE COMBOS ======================================================================= */
	
	if (bbq_rub !== undefined) {
		$('input[name="properties[BBQ Rub]"]').val(bbq_rub).addClass('valid');
		//console.log("BBQ Rub: " + bbq_rub);
	}
	
	if (burgundy_wine !== undefined) {
		$('input[name="properties[Burgundy Wine Steak Seasoning]"]').val(burgundy_wine).addClass('valid');
		//console.log("Burgundy Wine Steak Seasoning: " + burgundy_wine);
	}
	
	if (drunk_chicken !== undefined) {
		$('input[name="properties[Drunk Chicken]"]').val(drunk_chicken).addClass('valid');
		//console.log("Drunk Chicken: " + drunk_chicken);
	}
	
	if (smokers_rub !== undefined) {
		$('input[name="properties[Smoker\'s Rub]"]').val(smokers_rub).addClass('valid');
		//console.log("Smoker\'s Rub: " + smokers_rub);
	}
	
	/* === SAUCE COMBOS ======================================================================= */
	
	if (slop_sauce !== undefined) {
		$('input[name="properties[Slop Sauce]"]').val(slop_sauce).addClass('valid');
		//console.log("Slop Sauce: " + slop_sauce);
	}
	
	if (grillin_chillin !== undefined) {
		$('input[name="properties[Grillin and Chillin Sauce]"]').val(grillin_chillin).addClass('valid');
		//console.log("Grillin and Chillin Sauce: " + grillin_chillin);
	}
	
	
	const slugify = str =>
		str
			.toLowerCase()
			.trim()
			.replace(/[^\w\s-]/g, '')
			.replace(/[\s_-]+/g, '-')
			.replace(/^-+|-+$/g, '');
	
	// Trying to rewrite this a more concise way...
	document.querySelectorAll(".bold_option_set .bold_option").forEach(bold_option => {
		var bold_title = slugify(bold_option.querySelector(".bold_option_title").textContent.trim());
		console.log(bold_title);
	});
};
